import { useState } from 'react';
import { useDispatch } from 'react-redux';
import ImageUploaderSingle from '@components/ImageUploaderSingle';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import { menusService } from '@services';
import { alertActions } from '@actions';
import { handleApiError } from '@helpers/api';
import { validateFileSize } from '@helpers/upload-file';
import { MB } from '@constants/file';

const MenuImageUpload = ({ label, menuId, entityId, imageUrl, isView, onChange }) => {
    const [isUploading, setIsUploading] = useState(false);

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const onUpload = async e => {
        const file = e.target.files[0];
        if (!file) return;
        const { error, metric, size } = validateFileSize(file, 10 * MB);
        if (error) {
            dispatch(alertActions.error(t('apiErrors.file_size_too_large', { size, metric })));
            return;
        }
        try {
            setIsUploading(true);
            const data = new FormData();
            data.append('file', file);
            data.append('fileName', file.name);
            const response = await menusService.uploadItemImage(data, menuId, entityId);
            onChange(response.publicUrl);
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsUploading(false);
            e.target.value = '';
        }
    };

    return (
        <div style={{ gridColumn: '1 / -1', display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Typography variant="body2" color="textPrimary">
                {label}
            </Typography>
            <Typography variant="caption" sx={{ color: 'var(--text-secondary)' }}>
                {t('MenusPage.itemPhotoFormat')}
            </Typography>
            <ImageUploaderSingle
                style={{ marginTop: 4 }}
                logoUrl={imageUrl}
                disabled={isView}
                isUploading={isUploading}
                maxSize={10 * MB}
                extensions=".jpg,.jpeg,.png"
                cropConfig={{ aspectRatio: 1, outputMinWidth: 720, outputMaxWidth: 1440 }}
                uploadLogo={onUpload}
                onDelete={() => onChange('')}
            />
        </div>
    );
};

export default MenuImageUpload;
